import './Stakeholder.scss'
import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom"
import { withRouter } from '../../helpers/withRouter'
import {Layout, Spin, Icon, Menu, Dropdown, Button, Col, Row, message, notification} from 'antd'
import { useTranslation } from "react-i18next"
import { StakePublic, StakePrivate } from '../'
import Footer from './Footer'
import { ModalChangePassword } from '../../layouts/Private/components'
import { getDomainPromise, getUserByIdPromise, changePasswordPromise } from './promises'
import { SessionStorageService } from '../../services'

import ImageResources from "../../layouts/commonComponent/components/ExternalResources/ImageResources";
import i18nextConfig from "../../config/i18next";

const { Header } = Layout

const Stakeholder = ({ match, domain }) => {
	const { t } = useTranslation();
	const [cliente, setCliente] = useState(null)
	const [user, setUser] = useState(null)
	const [isLoading, setIsLoading] = useState(true)
	const [isLoggedIn, setIsLoggedIn] = useState(false)
	const [isModalChangePasswordVisible, setIsModalChangePasswordVisible] = useState(false)

	document.title = "Portal de Usuarios"

	useEffect(() => {
		getDomainPromise(domain ?? match.params.domain).then(c => {
			setCliente(c.data)

			if(c.data) {
				const userId = SessionStorageService.read('portal-user-id')
				if(userId !== null && userId !== '') {
					getUserByIdPromise(c.data.id, userId).then(u => {
						if(u.data !== null && u.data !== '') {
							handleLogin(u.data, SessionStorageService.read('portal-user-status'))
						}
						setIsLoading(false)
					})
				}else {
					setIsLoading(false)
				}
			}
		})
	}, [])

	const handleLogin = async (data, code) => {
		let record = data.record
		const cliente = data.client
		if(code === 'x') {
			record.activeUser = true
		}else if(code === '200' || code === '202') {
			record.activeUser = (code === '200')
			SessionStorageService.create('portal-user-id', record.id)
			SessionStorageService.create('portal-user-status', code)
			if(code === '202') {
				message.warn({content: t('messages.aml.recommended.change.pwd')})
			}
		}else {
			record.activeUser = false
		}
		setCliente(cliente)
		setUser(record)
		setIsLoggedIn(true)
  }

	const handleLogout = async (e) => {
		setIsLoggedIn(false)
		setUser(null)
		SessionStorageService.delete('portal-user-id')
		SessionStorageService.delete('portal-user-status')
  }

	const handleOpenModalChangePassword = () => {
		setIsModalChangePasswordVisible(true)
	}

	const handleCloseModalChangePassword = () => {
		setIsModalChangePasswordVisible(false)
  }

 	const handleSaveModalChangePassword = (passwordCurrent, passwordNew, passwordNewConfirm) => {
    	changePasswordPromise(user.id, passwordCurrent, passwordNew, passwordNewConfirm)
			.then(response => {
				if (response.data.status === 201 || response.data.status === 202) { //responseCode -> 202-00
					setIsModalChangePasswordVisible(false)
					if(!user.activeUser) {
						let _u = {...user, activeUser: true}
						SessionStorageService.create('portal-user-status', '200')
						setUser(_u)
					}
					notification['success']({message: i18nextConfig.t('messages.aml.success.passwordSuccesfullyUpdated')})
					handleLogout()
				} else {
					const errorMessages = {
						"400-10": 'messages.aml.errors.passwordCannotBeInLogin',
						"400-20": 'messages.aml.errors.passwordMustHaveBetween8and30Chars',
						"400-30": 'messages.aml.errors.passwordMustBeAlphanumeric',
						"400-40": 'messages.aml.errors.passwordMustHaveLowerCaseLetter',
						"400-50": 'messages.aml.errors.passwordMustHaveUpperCaseLetter',
						"400-60": 'messages.aml.errors.youCannotUsePreviousPasswords',
						"400-70": 'messages.aml.errors.invalid.current.pwd',
						"400-80": 'messages.aml.errors.newPwdIdenticalToCurrent',
						"500": 'messages.aml.errors.unknownError'
					};
					const validationMessage = errorMessages[response.data.data.code] || 'messages.aml.errors.unknownError';
					notification['error']({message: i18nextConfig.t(validationMessage)});
				}
			}).catch(data => {
			notification['error']({message: i18nextConfig.t('messages.aml.errors.unknownError')})
		})
    }


	const dropdownMenu = (
		<Menu>
			<Menu.Item>
				<Link to={ '#' } onClick={ handleOpenModalChangePassword }>
					<Icon type="lock" /> &nbsp;{ t('messages.aml.changePwd') }
				</Link>
			</Menu.Item>
			<Menu.Item>
				<Link to={ '#' } onClick={ handleLogout }>
					<Icon type="logout" /> { t('messages.aml.logout') }
				</Link>
			</Menu.Item>
		</Menu>
	)

	const getUrlPerson = (cliente, clCliente) => {
		if(cliente.outsourcer && clCliente?.subcliente) {
			return ('/getImageClient?clientId=' + cliente.id + '&subclienteId=' + clCliente.subcliente.id)
		}else {
			return ('/getImageClient?clientId=' + cliente.id)
		}
	}

	return (
		<div className="stakeholder">
			{ cliente ?
				<>
					<Header className="header">
						<div className="logo">
							<ImageResources key={Math.random()} url={getUrlPerson(cliente, user)} ></ImageResources>
						</div>
						{ isLoggedIn && user !== null &&
							<div className="current-user">
						<Dropdown overlay={ dropdownMenu }>
							<Button>
							<Icon type="user" /> { user.nombre } <Icon type="caret-down" />
							</Button>
						</Dropdown>
							</div>
						}
					</Header>
					{ isLoading ? <Col className="row-loading"><Spin size="large"/></Col>
						:
						isLoggedIn ?
							<>
							{ <StakePrivate client={cliente} currentUser={user} /> }
							{ (isModalChangePasswordVisible) &&
								<ModalChangePassword
									visible={ true }
									isForced={user.activeUser === false}
									onOk={ handleSaveModalChangePassword }
									onCancel={ handleCloseModalChangePassword }
									/>
							}
							</>
						:
							<StakePublic client={cliente} successHandler={handleLogin} />
					}
					<Footer country={cliente?.pais ?? cliente?.country} client={cliente} />
				</>
			:
				<div align="center"><br/><br/><br/><h1>Cliente no existe</h1></div>
			}
		</div>
	)
}

export default withRouter(Stakeholder)
